import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";

export default class MessageTemplatesUpdated extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "messageTemplateUpdated";
    }

    public receive(payload: CometOperatorApplication.MessageTemplateUpdatedCometMessageOpenApiModel): void {
        OperatorAccountStore.UPDATE_MESSAGE_TEMPLATES(payload.data);
    }

}